export default "__VITE_ASSET__CHQBm7pm__"